export default __webpack_public_path__ + "locales/ro/JavascriptSdk.json?hash=4d1b453d38a6c39ad98d2049976cebf1";